import React, { useEffect } from 'react'
import useAuth from '../context/userContext'

const ActivityRoleFetcher = () => {
  const { user, refreshActivityRole } = useAuth()

  useEffect(() => {
    // If user is activity_user but doesn't have activity_role, fetch it
    if (user?.user_type === 'activity_user' && !user?.activity_role) {
      console.log('Activity user without role detected, fetching...')
      refreshActivityRole()
    }
  }, [user, refreshActivityRole])

  return null // This component doesn't render anything
}

export default ActivityRoleFetcher
